import React from 'react';

const DepositDetailModal = ({ isOpen, onClose, deposit }) => {
    if (!isOpen) return null;

    if (!deposit) {
        return (
            <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body text-center py-4">
                            <div className="spinner-border text-primary" role="status"></div>
                            <div className="mt-2 text-muted">กำลังโหลดข้อมูล...</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            <i className="bi bi-wallet2 me-2"></i>รายละเอียดมัดจำ #{deposit.id}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body p-0">
                        <div className="p-3 bg-light border-bottom">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="text-muted">วันที่สร้าง</span>
                                <span className="fw-bold">
                                    {new Date(deposit.created_at).toLocaleDateString('th-TH')} {new Date(deposit.created_at).toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' })}
                                </span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="text-muted">สถานะ</span>
                                <span className={`badge ${deposit.amount_remaining > 0 ? 'bg-success' : 'bg-secondary'}`}>
                                    {deposit.status === 'active' && deposit.amount_remaining > 0 ? 'Active' : 'Used/Refunded'}
                                </span>
                            </div>
                        </div>

                        <div className="p-3">
                            <div className="mb-3">
                                <label className="small text-muted mb-1">ลูกค้า</label>
                                <div className="d-flex align-items-center">
                                    <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-2" style={{ width: 32, height: 32 }}>
                                        <i className="bi bi-person"></i>
                                    </div>
                                    <div>
                                        <div className="fw-bold">{deposit.customer_name}</div>
                                        <div className="small text-muted">{deposit.customer_phone || '-'} (ID: {deposit.member_id})</div>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-6">
                                    <div className="p-2 border rounded bg-white h-100">
                                        <div className="small text-muted">ยอดมัดจำเริ่มต้น</div>
                                        <div className="fs-5 fw-bold text-primary">{Number(deposit.amount_initial).toLocaleString()} ฿</div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="p-2 border rounded bg-white h-100">
                                        <div className="small text-muted">ยอดคงเหลือ</div>
                                        <div className="fs-5 fw-bold text-success">{Number(deposit.amount_remaining).toLocaleString()} ฿</div>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="small text-muted mb-1">ช่องทางชำระ</label>
                                <div>
                                    {deposit.payment_method === 'transfer' ? (
                                        <span className="badge bg-info text-dark"><i className="bi bi-bank me-1"></i>โอนเงิน</span>
                                    ) : (
                                        <span className="badge bg-secondary"><i className="bi bi-cash me-1"></i>เงินสด</span>
                                    )}
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="small text-muted mb-1">หมายเหตุ</label>
                                <div className="p-2 bg-light rounded text-break">
                                    {deposit.note || '-'}
                                </div>
                            </div>

                            {deposit.created_by && (
                                <div className="text-end text-muted x-small">
                                    ทำรายการโดย: {deposit.created_by}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>ปิด</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DepositDetailModal;
